import { Field } from 'factorial-form'
import { DataSchemaItemFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/DayPicker'

interface Props {
  dataSchemaItem: DataSchemaItemFragment
  field: Field
}

export const DateField = observer(({ dataSchemaItem, field }: Props) => {
  return (
    <DayPicker
      mandatory={dataSchemaItem.required}
      label={dataSchemaItem.label}
      mode="single"
      value={field.value}
      onChange={(newValue) => field.set(newValue)}
    />
  )
})
